@if (saving) {
  <xui-loading-spinner></xui-loading-spinner>
}
@if (form !== null && !saving) {
  <form class="appointment-edit-form" [formGroup]="form" [class.form-validated]="validate">
    <!-- Label only for non-patient appointment types. For patient appointments the title is
         inferred from the patient's name, so showing it here would just duplicate that. -->
    @if (!selectedType?.isPatientAppointment) {
      <mat-form-field appearance="fill" class="w-100">
        <mat-label>Label</mat-label>
        <input matInput [formControlName]="'title'" type="text" maxlength="100"/>
      </mat-form-field>
    }
    @if (selectedType?.isPatientAppointment) {
      <div class="w-100">
        @if (hasPatient) {
          <mat-form-field appearance="fill" class="w-100">
            <mat-label>Patient</mat-label>
            <input readonly matInput [value]="(patient?.profileId ? patient.profileId.toString().padStart(4, '0') : '') + ' - ' + (patient?.displayName || '')">
          </mat-form-field>
        }
        @if (hasTemporaryPatientDetails) {
          <div class="w-100 mb-3" formGroupName="appointmentMetaData">
            <div class="d-flex align-items-center justify-content-between mb-1">
              <span class="text-muted">Temporary Patient Details</span>
              <button mat-icon-button *xuiPermissionRequired="'Clinical.Patients.Write'" (click)="addNewPatient()">
                <mat-icon>library_add</mat-icon>
              </button>
            </div>
            <mat-form-field appearance="fill" class="w-100">
              <mat-label>Name</mat-label>
              <input readonly matInput [value]="temporaryPatientName">
            </mat-form-field>
            <!-- Cell and email are editable on edit (always shown) so a temporary patient's
                 contact details can be captured or corrected; they persist via
                 appointmentMetaData on save. -->
            <mat-form-field appearance="fill" class="w-100">
              <mat-label>Cell</mat-label>
              <input matInput [formControlName]="'cell'" type="tel">
            </mat-form-field>
            <mat-form-field appearance="fill" class="w-100">
              <mat-label>Email</mat-label>
              <input matInput [formControlName]="'email'" type="email">
            </mat-form-field>
          </div>
        }
      </div>
    }
    @if (isRecurring) {
      <div class="recurring-banner">
        <mat-icon class="recurring-banner-icon" inline>repeat</mat-icon>
        <span class="recurring-banner-text">{{ recurrenceSummary }}</span>
      </div>
    }
    <mat-form-field appearance="fill" class="w-100">
      <mat-label>Start Date & Time</mat-label>
      <xui-mat-datetime [formControlName]="'date'" #datetime="matDatetime" />
      <button mat-icon-button matSuffix (click)="datetime.togglePicker()">
        <mat-icon>today</mat-icon>
      </button>
    </mat-form-field>
    @if (dateLocked) {
      <div class="recurring-error">{{ dateLockedMessage }}</div>
    }
    <mat-form-field appearance="fill" class="w-100">
      <mat-label>End Date & Time</mat-label>
      <xui-mat-datetime [formControlName]="'endDate'" #endDatetime="matDatetime" />
      <button mat-icon-button matSuffix (click)="endDatetime.togglePicker()">
        <mat-icon>today</mat-icon>
      </button>
    </mat-form-field>
    @if (showLocationSelector) {
      <mat-form-field appearance="fill" class="w-100">
        <mat-label>Location</mat-label>
        <mat-select [formControlName]="'practiceLocationId'">
          @for (location of activeLocations; track location.id) {
            <mat-option [value]="location.id">{{location.name}}</mat-option>
          }
        </mat-select>
      </mat-form-field>
    }
    <app-appointment-clash-banner
      [locationId]="clashLocationId"
      [practitionerId]="clashPractitionerId"
      [start]="form.get('date')?.value"
      [end]="form.get('endDate')?.value"
      [excludeAppointmentId]="appointment.id"
      [originalStart]="originalStart"
      [originalEnd]="originalEnd"
      [originalLocationId]="originalLocationId"
      [appointmentTypeFiltersActive]="appointmentTypeFiltersActive">
    </app-appointment-clash-banner>
    <mat-form-field appearance="fill" class="w-100 compact mat-background-reset mb-3" [style.background-color]="selectedType.displayStyle" subscriptSizing="dynamic">
      <mat-label>Appointment Status</mat-label>
      <mat-select [formControlName]="'appointmentType'" required>
        @for (type of appointmentTypeOptions; track type) {
          <mat-option [value]="type.id" [style.background-color]="type.displayStyle">{{type.title}}</mat-option>
        }
      </mat-select>
    </mat-form-field>
    <mat-form-field appearance="fill" class="w-100">
      <mat-label>Booking Comment</mat-label>
      <textarea matInput [formControlName]="'comment'" maxlength="250"></textarea>
    </mat-form-field>
  </form>
}
